import { ReactElement } from 'react'

import { ExpandedRowsContextProvider } from '@features/reports/contexts/expandedRowsContext'
import { ProfitAndLossReport } from '@features/reports/views/NL/profitAndLossReport'
import { useProfitAndLossData } from '@features/reports/views/NL/profitAndLossReport/hooks/useProfitAndLossData'

export const ProfitAndLoss = (): ReactElement => {
  const { allExpandableIds } = useProfitAndLossData()

  return (
    <ExpandedRowsContextProvider allExpandableIds={allExpandableIds}>
      <ProfitAndLossReport />
    </ExpandedRowsContextProvider>
  )
}
